// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1xNzO","signatureBlock":"Footer_signatureBlock__Chjih","signature":"Footer_signature__2Ep4u"};